import * as docx from 'docx';
import {saveAs} from 'file-saver';
import * as docxFunc from './Docxhelper';
import {IControl, IQuestionList} from './InterfaceControl';
import { getDocxElementsFromString } from '../WysiwygEditor/WysiwygHelpers';

export function generateControlListDocx(Props: IControl, controlListApproved: boolean = false) {
    const generationTime = new Date(Date.now()).toLocaleString();
    const emptyText = controlListApproved ? 'Brak' : '';

      const tableBasicInfo = new docx.Table({
        columnWidths: [3505, 5505],
        rows: [
            docxFunc.detailRow('Numer kontroli:', Props.number || emptyText),
            docxFunc.detailRow('Numer projektu:', Props.project.metadata.businessId || emptyText),
            docxFunc.detailRow('Tytuł projektu:', Props.project.title || emptyText),
        ],
    });

    const tableBeneficiaryInfo = new docx.Table({
        columnWidths: [3505, 5505],
        rows: [
            docxFunc.detailRow('Identyfikator beneficjenta:', Props.project.beneficiaryIdentityNumber || emptyText),
            docxFunc.detailRow('Nazwa beneficjenta:', Props.project.beneficiaryName || emptyText),
            docxFunc.detailRow('Adres beneficjenta:', Props.project.beneficiaryAddress || emptyText),
        ],
    });

    const tableSubjectOfControlInfoTop = (): docx.Table => {
        let rows: docx.TableRow[] = [
            docxFunc.detailRow('Tryb kontroli:', Props.controlMode || emptyText),
            docxFunc.detailRow('Typ kontroli:', Props.controlType || emptyText),
            docxFunc.detailRow('Rodzaj kontroli:', Props.controlKind || emptyText),
            docxFunc.detailRow('Zespół kontrolujący:', Props.controlTeam || emptyText),
            docxFunc.detailRow('Zastosowana lista sprawdzająca:', Props.questionList.name || emptyText),
            docxFunc.detailRow('Planowany termin kontroli:', Props.plannedTerm || emptyText),
        ];
        if(Props.controlStatus !== 'Planowana') {
            rows.push(docxFunc.detailRow('Data rozpoczęcia kontroli:', controlListApproved ? Props.term || emptyText : 'Brak daty rozpoczęcia kontroli'));
        }
        rows.push(docxFunc.detailRow('Podmiot kontrolujący:', controlListApproved ? Props.controllingEntity || 'Brak' : 'Brak podmiotu kontrolującego'));
        rows.push(docxFunc.detailRow('Podmioty kontrolowane:', controlListApproved ? Props.allControlledParties || 'Brak': 'Brak podmiotów kontrolowanych'));
        rows.push(docxFunc.detailRow('Miejsca przeprowadzenia kontroli:', controlListApproved? Props.controlPlaces.length > 0 ? Props.controlPlaces.map(p => p.name).join("; ") : 'Brak' : 'Brak miejsc przeprowadzenia kontroli' ));
        rows.push(docxFunc.detailRow('Inne kontrolowane projekty:', controlListApproved? Props.otherControlledProjectNumbers?.length > 0 ? Props.otherControlledProjectNumbers.join("; ") : 'Brak innych kontrolowanych projektów' : 'Brak innych kontrolowanych projektów' ));
        rows.push(docxFunc.detailRow('Kontrolowane zamówienia:', !controlListApproved || Props.orders.length === 0 ? 'Brak kontrolowanych zamówień' : ''));
        return new docx.Table({
            columnWidths: [3505, 5505],
            rows: rows
        });
    };

    const tableSubjectOfControlInfoBottom = new docx.Table({
        columnWidths: [3505, 5505],
        rows: [
            docxFunc.detailRow('Numery kontrolowanych WoP:', controlListApproved ? Props.paymentClaims.length > 0 ? Props.paymentClaims.map(p => p.number).join(", ") : 'Brak kontrolowanych wniosków' : 'Brak kontrolowanych wniosków' ),
        ],
    });

    function questionBlocks(questionList:IQuestionList, controlListApproved: boolean) {
        const rows: any = [];

        if (questionList.blocksInList) {
            questionList.blocksInList.forEach((block, blockIndex) => {
                const isBlockInactive = Props.answerBlockStatus.find(x => x.blockRef === block.id)?.active === false;//block.questionsInBlock.every(q => q.answers.answer === 'ND');
                rows.push(docxFunc.blockName(`${++blockIndex}. ${block.name}`, 26, false, true, false, true));

                if(isBlockInactive)
                {
                    rows.push(docxFunc.textInParagraphWithSpacing(`Nie dotyczy`, false, false, false));
                }
                else
                {
                    block.questionsInBlock.forEach((question, questionIndex) => {
                        rows.push(docxFunc.textInParagraphWithSpacing(`${blockIndex}.${++questionIndex} ${question.questionContent}`, false, true, false));
                        if(controlListApproved) {
                            rows.push(docxFunc.answer(question.answers?.answer));
                            const textAnswer = question.answers?.textAnswer;
                            if (!!textAnswer) {
                                rows.push(docxFunc.label('UWAGA: '));

                                const docxElements = getDocxElementsFromString(textAnswer);

                                docxElements.forEach((element: docx.Paragraph) => {
                                    rows.push(element);
                                });
                            }
                            const attachments = question.answers?.attachments;
                            if (attachments?.length > 0) {
                                rows.push(docxFunc.label('ZAŁĄCZNIKI: ', true, 110));
                                question.answers?.attachments.forEach(doc => {
                                    rows.push(docxFunc.textAnswer(doc.document.file.fileName, true));
                                });
                            }
                        }
                    });
                }
            })
        } else {
            rows.push(docxFunc.textInParagraphWithSpacing(`${controlListApproved ? ' Brak' : ''}`, false, true , false));
        }
        return rows;
    }

    const doc = new docx.Document({
        sections: [{
            properties: {
            },
            headers: {
                default: new docx.Header({
                    children: [
                        docxFunc.pageHeader(Props.number),
                        docxFunc.pageHeader('Utworzono ' + generationTime),
                    ],
                }),
            },
            children: [
                docxFunc.draft(controlListApproved),
                docxFunc.header('Lista sprawdzająca dla kontroli'),
                docxFunc.header(Props.number),
                docxFunc.brakeLine(20),
                docxFunc.brakeLine(20),
                docxFunc.blockTitle('Informacje wstępne'),
                docxFunc.subTitleWithLines('Informacje o projekcie'),
                tableBasicInfo,
                docxFunc.brakeLine(1),
                docxFunc.subTitleWithLines('Dane beneficjenta ', -1),
                tableBeneficiaryInfo,
                docxFunc.brakeLine(1),
                docxFunc.subTitleWithLines('Informacje o kontroli'),
                tableSubjectOfControlInfoTop(),
                ...docxFunc.ordersTable([["Numer ogłoszenia o zamówieniu", "Nazwa zamówienia", "Kontrakty"], ...Props.orders?.map((order: any) => [order.orderNumber, order.orderName, docxFunc.formatContractsValue(order.contracts)])], controlListApproved),
                tableSubjectOfControlInfoBottom,
                docxFunc.brakeLine(1),
                docxFunc.subTitle('Bloki z pytaniami:', 260, 60),
                ...questionBlocks(Props.questionList, controlListApproved)
            ],
            footers: {
                default: new docx.Footer({
                    children: [
                        new docx.Paragraph({
                            alignment: docx.AlignmentType.CENTER,
                            children: [
                                new docx.TextRun({
                                    children: [
                                        "Strona: ",
                                        docx.PageNumber.CURRENT,
                                        " z ",
                                        docx.PageNumber.TOTAL_PAGES
                                    ],
                                    size: 16,
                                    font: 'Arial',
                                    color: '#616161'
                                }),

                            ],
                        }),
                    ],
                }),
            },
        }],
    });

    docx.Packer.toBlob(doc).then((blob) => {
        const mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        const docblob = blob.slice(0, blob.size, mimeType);
        saveAs(docblob, `${Props.number}_LS.docx`)
    });
}
